<div class="flex items-center justify-center">
  <div class="relative w-12 h-12">
    <!-- Outer ring -->
    <div class="absolute inset-0 border-3 border-gray-200 dark:border-slate-700 rounded-full"></div>
    <!-- Spinning ring -->
    <div class="absolute inset-0 border-3 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
</div>
